import styles from './AllClientsProdctsTable.module.css'
import { Table } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import './AllClientsProdctsTable.css'
import { useTranslation } from 'react-i18next'
import {ReactComponent as PencilIcon} from 'assets/icons/pencilIcon.svg'
import ReactLoading from "react-loading";
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { axiosConfig } from 'utils/axiosConfig'
function AllClientsProdctsTable(props:any) {
    const {t}= useTranslation()
    const { items ,getUserProducts ,deleteItem,isDeleting,getAllUsers } = props
    const user =useSelector((state:any)=>state?.GlobalReducer?.user)
    const [payingAmount ,setPayingAmount] = useState<any>([])
    const params = useParams()
    const [isLoading ,setIsLoading] = useState(false)
    
    function payInstallment(installmentId:String,index:any){
        if(!payingAmount?.[index]){
            toast.error(t('Paying Amount Is Required'))
            return
        }
        setIsLoading(true)
        
        let modifiedPayingAmount = [...payingAmount]
        modifiedPayingAmount[index]=0
        setPayingAmount(modifiedPayingAmount)
        const formData  = new FormData()
        formData.append('paying_amount',payingAmount?.[index])
        formData.append('installment_id',String(installmentId))
        axiosConfig.post(`/user/pay-installment-for-user/${params?.id}`,formData,{
        headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`
        }
        }).then(res=>{
            setIsLoading(false)
            toast.success(t(`User Installment Paid Successfully Successfully`))
            getUserProducts()
            setPayingAmount([])
            let payingAmountItems=items?.length ||0
            setPayingAmount([...Array(payingAmountItems)])
        }).catch(err=>{
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
        })
    }
    function handleChangePayingAmount(value:any,index:any,paidAmount:any,price:any){
        if(Number(value)+Number(paidAmount)>Number(price)){ 
            value=price-paidAmount
        }
        let modifiedPayingAmount = [...payingAmount]
        modifiedPayingAmount[index]=value
        setPayingAmount(modifiedPayingAmount)
    }
    useEffect(()=>{
        setPayingAmount([])
        let payingAmountItems=items?.length ||0
        setPayingAmount([...Array(payingAmountItems)])
    },[items])
    return (
        <>
            <Table responsive striped className={`${styles['appointments__table']} table table-responsive`}>
                <thead>
                    <th>{t('Product Name')}</th>
                    <th>{t('Price')}</th>
                    <th>{t("Warranty Start Date")}</th>
                    <th>{t("Warranty End Date")}</th>
                    <th>{t("Warranty Status")}</th>
                    <th>{t("Created At")}</th>
                    <th></th>
                </thead>
                <tbody>
                    {
                        items &&items?.map((item:any,index:number)=>(
                            <tr key={item?.id}>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> {item?.product_name} </p>
                                </td>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> {item?.price} {t('AED')}</p>
                                </td>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> {item?.warranty_start_date} </p>
                                </td>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> {item?.warranty_end_date} </p>
                                </td>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> 
                                        {
                                            item?.warranty_status=='in_warranty' ?t('In Warranty'):
                                            item?.warranty_status=='out_warranty' ?t('Out Warranty'):''
                                        }
                                    </p>
                                </td>
                                <td>
                                    <p className={`${styles['appointments__table-name']} text-capitalize`}> {item?.created_at} </p>
                                </td>
                                <td>
                                    {
                                        user?.permission_type!='viewer' &&
                                            <Link to={`/our-clients/update-client-products/${params?.id}?product_id=${item?.id}`} className={styles['appointments__table-link']}>
                                                <PencilIcon className={styles['appointments__table-link-icon']}/>
                                                {t('Update Product')}
                                            </Link>
                                    }
                                    {
                                        (user?.permission_type=='admin' &&deleteItem)&&
                                        <>
                                            <button onClick={()=>{deleteItem(params?.id,index,item?.id)}} disabled={isDeleting[index]}
                                                className={styles['appointments__table-delete']}>
                                                {
                                                    !isDeleting[index]?t('Delete')
                                                    :<ReactLoading type={"spin"} color={'red'} height={20} width={20} />
                                                }
                                            </button>
                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </>
    )
}

export default AllClientsProdctsTable